var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeekly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 29,
    height: 22,
    rx: 3,
    fill: "#21908C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9078 15L9.19084 7.245H10.3788L12.6338 13.944H12.2268L14.6138 7.245H15.4828L17.7268 13.944H17.3528L19.6848 7.245H20.8068L18.0678 15H17.0888L14.9108 8.62H15.1418L12.8758 15H11.9078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekly);
export default __webpack_public_path__ + "static/media/weekly.7165c0e8bb9fce65b944eeace46eaf57.svg";
export { ForwardRef as ReactComponent };